import checkIsSocialMediaBrowser from '@/idv2/utils/check-is-social-media-browser';
import type { DeviceInfo } from '@/idv2/utils/get-device';

export type SkipLivenessReason =
  | 'unavailable_in_social_iframe'
  | 'unavailable_in_iframe'
  | 'unavailable_on_device'
  | 'failed'
  | 'unknown';

const getSkipReason = ({
  deviceInfo,
  isInIframe,
  isUnavailable,
}: {
  deviceInfo: DeviceInfo;
  isInIframe: boolean;
  isUnavailable: boolean;
}): SkipLivenessReason => {
  if (!isUnavailable) {
    return 'failed';
  }

  if (!deviceInfo?.hasSupportForWebauthn) {
    return 'unavailable_on_device';
  }

  if (!isInIframe) {
    return 'unknown';
  }
  if (checkIsSocialMediaBrowser()) {
    return 'unavailable_in_social_iframe';
  }
  return 'unavailable_in_iframe';
};

export default getSkipReason;
